import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteAnaliseMercadoFormModalModule } from '../form/modal';
import { ClienteAnaliseMercadoLancamentoModule } from '../lancamento';
import { ClienteSituacaoModule } from '../../pessoa/cliente/situacao';
import { ClienteCadastroModule } from '../../pessoa/cliente/cadastro';
import { ClientePipeSharedModule } from '../../pessoa/cliente/pipes';
import { ClienteFormModalModule } from '../../pessoa/cliente/form-modal';
import { ClienteCentralCompraFormModule } from '../../pessoa/cliente/central-compra/form';
import { ClienteCentralCompraParticipanteFormModule } from '../../pessoa/cliente/central-compra/participante/form';
import { ClienteCarteiraPreBaixarModule } from '../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModule } from '../../cliente-carteira/baixar';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CustomerShareIndicadorBadgeModule } from '../../pic/customer-share/indicador/badge';

import { ClienteAnaliseMercadoClienteListComponent } from './list';
import { ClienteAnaliseMercadoClienteTableComponent } from './table';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoFormModalModule,
        ClienteAnaliseMercadoLancamentoModule,
        ClienteSituacaoModule,
        ClienteCadastroModule,
        ClientePipeSharedModule,
        ClienteFormModalModule,
        ClienteCentralCompraFormModule,
        ClienteCentralCompraParticipanteFormModule,
        ClienteCarteiraPreBaixarModule,
        ClienteCarteiraBaixarModule,
        CdkScrollableModule,
        ScrollingModule,
        InfiniteScrollModule,
        CustomerShareIndicadorBadgeModule
    ],
    declarations: [
        ClienteAnaliseMercadoClienteListComponent,
        ClienteAnaliseMercadoClienteTableComponent
    ],
    exports: [
        ClienteAnaliseMercadoClienteListComponent
    ],
    providers: [ ]
})
export class ClienteAnaliseMercadoClienteModule { }
